import { DotLegalInfoDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import { useRemoveFromExcludedListDialog } from "./RemoveFromExcludedListDialog.hooks.ts";

export interface RemoveFromExcludedListDialogProps {
    contractId: string;
    userId: string;
    userFullName: string;

    onCloseDialog: () => void;
    onRemoveFromExcludedList: () => void;
}

function RemoveFromExludedListDialog(props: RemoveFromExcludedListDialogProps) {
    const { translateString } = useTranslation();
    const { inProgress, onRemoveFromExcludedList } = useRemoveFromExcludedListDialog(props);
    return (
        <DotLegalInfoDialog
            header={translateString("removeFromExcluded")}
            btnText={translateString("removeFromExcluded")}
            content={translateString("removeFromExcludedInformationText", { fullName: props.userFullName })}
            onCloseDialog={() => props.onCloseDialog()}
            onBtnClick={() => onRemoveFromExcludedList()}
            inProgress={inProgress}
        />
    );
}

export default RemoveFromExludedListDialog;
